export default __webpack_public_path__ + "static/media/avaliadores_inactive.73c67098.svg";